import React from 'react';
import {
  TextField,
  InputAdornment,
  Tooltip,
  IconButton,
  Box
} from '@mui/material';
import {
  Search as SearchIcon,
  HelpOutline as HelpIcon,
  Clear as ClearIcon
} from '@mui/icons-material';
import { useThemeSettings } from '../../../../contexts/ThemeContext';

/**
 * Search bar component with wildcard support
 */
const SearchBar = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search tickets...',
  fullWidth = true
}) => {
  const { t } = useThemeSettings();

  const searchTips = (
    <Box sx={{ p: 1 }}>
      <strong>{t ? t('Tickets.search_tips') : 'Search Tips'}:</strong>
      <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
        <li>{t ? t('Tickets.search_tip_1') : 'Use * as wildcard (e.g., "error*" matches "error", "errors", "error123")'}</li>
        <li>{t ? t('Tickets.search_tip_2') : 'Search matches title, description, location, device, and user'}</li>
        <li>{t ? t('Tickets.search_tip_3') : 'Search is case-insensitive'}</li>
      </ul>
    </Box>
  );

  return (
    <TextField
      fullWidth={fullWidth}
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {value && (
              <IconButton size="small" onClick={onClear}>
                <ClearIcon fontSize="small" />
              </IconButton>
            )}
            <Tooltip title={searchTips} arrow placement="bottom-end">
              <IconButton size="small">
                <HelpIcon fontSize="small" color="action" />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        )
      }}
      sx={{ maxWidth: 400 }}
    />
  );
};

export default SearchBar;
